import { gql } from '@apollo/client'

export default gql`
  fragment PersonComponent on Person {
    id
    description
    facebook
    image {
      url
    }
    instagram
    jobTitle
    location
    name
    twitter
  }
`
